import { render, staticRenderFns } from "./SelectBranch.vue?vue&type=template&id=5850ed44&scoped=true&"
import script from "./SelectBranch.vue?vue&type=script&lang=js&"
export * from "./SelectBranch.vue?vue&type=script&lang=js&"
import style0 from "./SelectBranch.vue?vue&type=style&index=0&id=5850ed44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5850ed44",
  null
  
)

export default component.exports